module.exports = __webpack_public_path__ + "static/media/cloudflare-icon.2886a35c.svg";